import {flattenDeep, xorBy} from 'lodash';
import { devLog } from '~/assets/js/helpers';
import {ArrayObject} from './../interfaces';
/**
 * 
 * @param array The array of objects to iterate through (must have the `prop` property as well as a property called `children`)
 * @param prop? Optional
 */
export function flattenByProp<T extends ArrayObject>(array: Array<T>, prop?: string): Array<T> {
    let final: ArrayObject[] = [];
    if (prop) {
        for (let el of array) {
            final.push(el[prop]);
            if (el.children && Array.isArray(el.children) && el.children.length > 0) final.push(flattenByProp(el.children, prop));
        }
    }
    else {
        for (let el of array) {
            final.push(el)
            if (el['children']) final.push(el['children']);
            if (el.children && Array.isArray(el.children) && el.children.length > 0) final.push(flattenByProp(el.children, undefined));
        }
    }

    return flattenDeep(final);
}

export function removeFromArray<T>(arr: Array<T>, predicate: (item: T) => boolean){
    devLog('removing element %o from array %o', predicate, arr).info()
    const array = Array.from(arr)
    const slotIndex = array.findIndex(predicate);
    // console.log('slot index', slotIndex)
    if(slotIndex > -1){
        const half1 = array.slice(0, slotIndex)
        let half2 = []
        if(slotIndex+1 !== array.length) { half2.push(...array.slice(slotIndex+1)) }

        array.length = 0;

        array.push(...half1, ...half2);
        devLog('new array', array).info()
        devLog('xor: ', xorBy(array, arr, 'id')).info()
        return array;
    }else{
        return array;
    }
}